import { Link } from 'react-router-dom'
import { MapPin, Shield } from 'lucide-react'

const col = (title: string, links: Array<{ to: string; label: string; external?: boolean }>) => ({ title, links })

const columns = [
  col('About', [
    { to: '/about', label: 'About VICE' },
    { to: '/features', label: 'Features and Benefits' },
    { to: '/awa', label: 'AI Workflow Automation' },
    { to: '/for-agents', label: 'For USVI Agents' },
  ]),
  col('Help & Support', [
    { to: '/contact', label: 'Contact Us' },
    { to: '/help', label: 'Help & FAQ' },
    { to: '/security', label: 'Security' },
    { to: '/accessibility', label: 'Accessibility' },
  ]),
]

export function PublicFooter() {
  const year = new Date().getFullYear()
  return (
    <footer role="contentinfo" className="bg-primary text-neutral-200 mt-20">
      <div className="h-1 bg-vice-sunset" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link
            to="/"
            className="inline-flex items-center gap-4 rounded focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-4"
            aria-label="VICE — Virgin Islands Commercial Environment"
          >
            <img src="/logo-invert.png" alt="VICE" className="h-12 w-auto" />
            <span className="text-sm font-semibold text-neutral-100 leading-snug max-w-[16ch] border-l border-white/20 pl-4">
              Virgin Islands Commercial Environment
            </span>
          </Link>
          <p className="mt-4 text-sm max-w-sm leading-relaxed">
            Entry summary automation for U.S. Virgin Islands ports.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <p className="flex items-center gap-2">
              <MapPin size={15} aria-hidden="true" />
              U.S. Virgin Islands
            </p>
            <p className="flex items-center gap-2">
              <Shield size={15} aria-hidden="true" />
              WCAG 2.1 AA &middot; Section 508
            </p>
          </div>
          <p className="mt-8 text-sm sm:text-base font-semibold text-neutral-100">
            Built by{' '}
            <a
              href="https://metaphase.tech"
              target="_blank"
              rel="noreferrer"
              className="text-accent-sunset hover:text-accent-coral focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2 rounded"
            >
              MetaPhase
            </a>
          </p>
          <p className="mt-1 text-xs text-neutral-400">
            &copy; {year} VICE. All rights reserved.
          </p>
        </div>

        {columns.map(({ title, links }) => (
          <div key={title}>
            <h2 className="text-xs font-semibold uppercase tracking-wider text-white mb-3">
              {title}
            </h2>
            <ul className="space-y-2 text-sm">
              {links.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="hover:text-white focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2 rounded"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  )
}
